import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocationConfigService, OpenOrderTableComponent } from 'gung-standard';
import { DateUtilService } from 'gung-common';
import { JeevesOpenOrderTableListComponent } from 'gung-standard-jeeves';

@Component({
    selector: 'colmec-open-order-table',
    templateUrl: './colmec-open-order-table.component.html',
    styleUrls: ['./colmec-open-order-table.component.scss'],
    standalone: false
})
export class ColmecOpenOrderTableComponent extends JeevesOpenOrderTableListComponent {


  classSelector(key: number) {
    if (key === 0) {
      return {
        quote: true
      };
    }
    if (key === 13) {
      return {
        registered: true
      };
    }
    if (key === 11) {
      return {
        quote: true
      };
    }
    if (key === 10) {
      return {
        registrationInProgress: true
      };
    }
    if (key === 12) {
      return {
        blocked: true
      };
    }
    if (key === 5) {
      return {
        webRegistrationInProgress: true
      };
    }

    return {};
  }
}
